<template>

    <div class="md-layout" style="padding-top:20px">
   
    <md-card>
      <md-card-header>

        <md-avatar>
          <img src="@/assets/app.png" alt="Avatar">
        </md-avatar>

        <div class="md-title md-layout">
            <div >
                FaroCapital
            </div>
        </div>
        <div class="md-subhead md-layout">
            <p align="justify">
                Descarga Distribucion ad-hoc para colaboradores de empresa para plataforma <b>iOS</b> y <b>android</b>
            </p>
        </div>
      </md-card-header>


        <md-card-actions>
          <md-button :href="'itms-services://?action=download-manifest&url=https://'+url+'/manifest.plist'" class="md-icon-button md-primary" alt>
            <md-icon>phone_iphone</md-icon>
          </md-button>

          <md-button :href="'https://'+url+'/com.aditiva.farocapital.apk'" class="md-icon-button md-primary">
            <md-icon>android</md-icon>
          </md-button>

        </md-card-actions>
    </md-card>     

  </div>
</template>

<script>
import eventBus from '../bus'
export default {
    data: () => ({
        url: null
    }),     
    mounted: function(){
        eventBus.$emit('isLoading', false);
        this.url = this.$store.state.url;
    }
}
</script>

<style>

</style>